import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-gdo-payment-components',
    templateUrl: './gdo-payment-components.component.html',
    styleUrls: ['./gdo-payment-components.component.scss'],
    standalone: false
})
export class GdoPaymentComponentsComponent implements OnInit {
  public activeTab = 0;

  constructor(private router: Router, private route: ActivatedRoute, private destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((snap: any) => {
      if (snap && snap.params) {
        this.activeTab = snap.params.activeTab;
      }
    });
  }

  public executeSelectedChange = (event: { index: number }) => {
    switch (event.index) {
      case 0: // index of the tab
        this.router.navigate(['billing']);
        this.activeTab = 0;
        break;
      case 1:
        this.router.navigate(['/billing/billingHistory']);
        this.activeTab = 1;
        break;
    }
  };
}